import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import NavBar from '../../components/layout/NavBar'
import Footer from '../../components/layout/Footer'
import './contact.css'

// CRITICAL: Use our own Firebase backend instead of third-party EmailJS
// This ensures reliability, logging, and full control over customer communications

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    businessName: '',
    message: ''
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null) // 'success', 'error', null

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus(null)
    
    try {
      // CRITICAL: Use our own Firebase backend contact endpoint
      const response = await fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })

      if (response.ok) {
        const result = await response.json()
        console.log('✅ Contact form submitted successfully:', result)
        
        setSubmitStatus('success')
        
        // Clear form after successful submission
        setFormData({
          name: '',
          email: '',
          businessName: '',
          message: ''
        })
        
        // Show success message for 5 seconds
        setTimeout(() => setSubmitStatus(null), 5000)
        
      } else {
        const errorData = await response.json()
        console.error('❌ Contact form submission failed:', errorData)
        setSubmitStatus('error')
        
        // Clear error message after 5 seconds
        setTimeout(() => setSubmitStatus(null), 5000)
      }
    } catch (error) {
      console.error('❌ Contact form network error:', error)
      setSubmitStatus('error')
      
      // Clear error message after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact - block automation</title>
        <meta property="og:title" content="Contact - block automation" />
        <meta property="og:description" content="block better." />
      </Helmet>
      <NavBar />
      
      {/* Contact Form Section */}
      <div className="contact-form-container section-container">
        <div className="max-width">
          <div className="contact-content">
            <h1 className="contact-title">Get in Touch</h1>
            <p className="contact-description">
              Fill out the form below and we'll get back to you within 48 hours.
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Business Name</label>
                <input 
                  type="text" 
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  placeholder="Your business name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your needs" 
                  required
                ></textarea>
              </div>
              {/* SUCCESS MESSAGE */}
              {submitStatus === 'success' && (
                <div className="alert alert-success" style={{
                  backgroundColor: '#d4edda',
                  color: '#155724',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  border: '1px solid #c3e6cb'
                }}>
                  ✅ <strong>Message sent successfully!</strong> We'll get back to you within 48 hours.
                </div>
              )}

              {/* ERROR MESSAGE */}
              {submitStatus === 'error' && (
                <div className="alert alert-error" style={{
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  border: '1px solid #f5c6cb'
                }}>
                  ❌ <strong>Failed to send message.</strong> Please try again or email us directly at trevor@blockautomation.ai
                </div>
              )}

              <button 
                type="submit" 
                className="button button-primary"
                disabled={isSubmitting}
                style={{
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting ? (
                  <>
                    <span>🔄 Sending...</span>
                  </>
                ) : (
                  'Send Message'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Contact 